import { Component, ViewChild } from '@angular/core';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { VariantListTypes } from 'enums/VariantListTypes';
import { VariantListModel } from 'models/generated/Entities.GormCrm.VariantList';
import { VariantListOptionModel } from 'models/generated/Entities.GormCrm.VariantListOption';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { ProductService } from 'services/product.service';
import { ListVariantListsComponent } from './list-variant-lists.component';

@Component({
	selector: 'edit-variant-list',
	templateUrl: './edit-variant-list.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomInputComponent, CustomSelectComponent, TranslatePipe]
})
@ComponentUrl('edit-variant-list')
@CredentialRequired(CredentialType.ProductsAccessFull)
export class EditVariantListComponent {

	variantList = new VariantListModel();
	variantListTypes: SelectListItemModel[] = [];
	inputTypeEnum = InputType;
	variantListTypesEnum = VariantListTypes;
	loading = false;

	@ViewChild('saveButton') saveButton?: ButtonComponent;

	_variantListId: string = '';
	@UrlParam
	set variantListId(id: string) {
		if (id) {
			this.loading = true;
			this._variantListId = id;
			this.productService.getVariantList(id).then(variantList => {
				this.variantList = variantList;
				this.loading = false;
			});
			this.navigation.openParentView(this, 'edit-variant-list', ListVariantListsComponent);
		}
	}
	get variantListId() {
		return this.variantList?.id ?? this._variantListId;
	}

	constructor(private readonly navigation: NavigationService, private readonly productService: ProductService, private readonly formValidation: FormValidationService) {

		const options = VariantListTypes.getKeys();
		const variantListTypes: SelectListItemModel[] = [];
		options.forEach((value: string, key: VariantListTypes) => {
			variantListTypes.push(new SelectListItemModel(key, value));
		});
		this.variantListTypes = variantListTypes;
	}

	addOptionValue() {
		this.variantList.variantListOptions.push(new VariantListOptionModel());
	}

	removeOptionValue(index: number) {
		this.variantList.variantListOptions.splice(index, 1);
		this.formValidation.fieldStateChanged(this, true, false);
	}
	markAsPristine() { }

	saveVariantList() {
		this.variantList.include(vl => vl.variantListOptions);
		this.productService.createOrUpdateVariantList(this.variantList).then(variantList => {
			this._variantListId = variantList.id!;
			this.variantList = variantList;
			this.saveButton?.reset();
		});
	}
}
